import React from "react";
import Webcam from "react-webcam";
const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: { exact: "environment" },
};

const Camera = ({ modal, fileList, imageList }) => {
  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }
  return (
    <Webcam
      audio={false}
      height={720}
      screenshotFormat="image/jpeg"
      width={1280}
      style={{ position: "relative" }}
      videoConstraints={videoConstraints}
    >
      {({ getScreenshot }) => (
        <button
          style={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            background: "red",
            position: "absolute",
            bottom: "50px",
          }}
          onClick={() => {
            const imageSrc = getScreenshot();
            var file = dataURLtoFile(imageSrc, "image-1.png");
            fileList.push(file);
            imageList.push(URL.createObjectURL(file));
            modal(false);
          }}
        ></button>
      )}
    </Webcam>
  );
};
export default Camera;
